
import SaveMinus from "../../../assets/filled/SaveMinus.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SaveMinusIcon({ className, dataTestid = "SaveMinusIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SaveMinus data-testid={dataTestid} className={classes} {...rest} />
  );
}
